import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$3 = ".AnimatedContainer_module_container__fb438508{display:grid;grid-template-rows:0fr;transition:grid-template-rows var(--st-transition-duration) ease-out}.AnimatedContainer_module_open__fb438508{grid-template-rows:1fr}.AnimatedContainer_module_inner__fb438508{min-height:0;overflow:clip}";
collectCss(css$3);
var modules_d098bf60 = {"container":"AnimatedContainer_module_container__fb438508","open":"AnimatedContainer_module_open__fb438508","inner":"AnimatedContainer_module_inner__fb438508"};

export { css$3 as css, modules_d098bf60 as default };
//# sourceMappingURL=AnimatedContainer.module.css.mjs.map
